import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}
export default function ServiceCard({
  title,
  description,
  icon,
  link
}: ServiceCardProps) {
  return <div className="flex flex-col h-full bg-white rounded-lg shadow-md p-6 transition-all hover:shadow-xl border-t-4 border-primary card-lift group" data-id="element-409" data-mp="151fu6dym0n5h">
      <div className="text-primary mb-4 transform transition-transform group-hover:scale-110 group-hover:rotate-3" data-id="element-410" data-mp="103mqbrks458d">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-bold text-primary mb-2 group-hover:text-secondary transition-colors" data-id="element-411" data-mp="qb8hkeva9ycp">
        {title}
      </h3>
      <p className="text-slate mb-4 leading-relaxed" data-id="element-412" data-mp="mbzrbjzgcilw">{description}</p>
      <Link to={link} aria-label={`Read more about ${title}`} className="mt-auto inline-flex items-center text-primary font-medium hover:text-secondary transition-all group-hover:translate-x-2" data-id="element-413" data-mp="ha0m04k5jbmb">
        Read More <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" data-id="element-414" data-mp="764me5ryj012" />
      </Link>
    </div>;
}